var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_1917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.625 25H1.04167C0.416667 25 0 24.5833 0 23.9583V1.04167C0 0.416667 0.416667 0 1.04167 0H15.625C16.25 0 16.6667 0.416667 16.6667 1.04167V8.33333C16.6667 8.95833 16.25 9.375 15.625 9.375C15 9.375 14.5833 8.95833 14.5833 8.33333V2.08333H2.08333V22.9167H14.5833V16.6667C14.5833 16.0417 15 15.625 15.625 15.625C16.25 15.625 16.6667 16.0417 16.6667 16.6667V23.9583C16.6667 24.5833 16.25 25 15.625 25Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9582 13.5418H8.33317C7.70817 13.5418 7.2915 13.1252 7.2915 12.5002C7.2915 11.8752 7.70817 11.4585 8.33317 11.4585H23.9582C24.5832 11.4585 24.9998 11.8752 24.9998 12.5002C24.9998 13.1252 24.5832 13.5418 23.9582 13.5418Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9583 13.5415C23.6458 13.5415 23.4375 13.4373 23.2292 13.229L19.0625 9.06234C18.6458 8.64567 18.6458 8.02067 19.0625 7.604C19.4792 7.18734 20.1042 7.18734 20.5208 7.604L24.6875 11.7707C25.1042 12.1873 25.1042 12.8123 24.6875 13.229C24.4792 13.4373 24.2708 13.5415 23.9583 13.5415Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7917 17.7085C19.4792 17.7085 19.2708 17.6043 19.0625 17.396C18.6458 16.9793 18.6458 16.3543 19.0625 15.9377L23.2292 11.771C23.6458 11.3543 24.2708 11.3543 24.6875 11.771C25.1042 12.1877 25.1042 12.8127 24.6875 13.2293L20.5208 17.396C20.3125 17.6043 20.1042 17.7085 19.7917 17.7085Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_1917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b63c93395277df7e4c9ef385f800595a.svg";
export { ForwardRef as ReactComponent };